import { render, staticRenderFns } from "./MyReclamationInvoices.vue?vue&type=template&id=96cc5558&scoped=true&"
import script from "./MyReclamationInvoices.vue?vue&type=script&lang=js&"
export * from "./MyReclamationInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cc5558",
  null
  
)

export default component.exports